// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface String {
	/**
	 * Transforma a string em uma versão capitalizada, seguindo as regras definidas.
	 * As palavras especificadas nos arrays `extraLowerCaseWords` e `extraUpperCaseWords` podem
	 * ter seu caso alterado conforme as regras.
	 *
	 * @param options - Opções para personalizar o comportamento da função.
	 * @param {string[]} options.extraLowerCaseWords - Array de palavras extras que devem ser escritas em minúsculas.
	 * @param {string[]} options.extraUpperCaseWords - Array de palavras extras que devem ser escritas em maiúsculas.
	 * @returns A string original com as palavras capitalizadas conforme as regras especificadas.
	 * @example
	 * const name = 'josé da silva';
	 * console.log(name.toCapitalizedCase()); // Saída: "José da Silva"
	 * const phrase = 'cpf do usuário';
	 * console.log(phrase.toCapitalizedCase()) // Saída: "CPF do Usuário"
	 */
	toCapitalizedCase(options?: {
		extraLowerCaseWords?: string[];
		extraUpperCaseWords?: string[];
	}): string;
}

String.prototype.toCapitalizedCase = function ({
	extraLowerCaseWords = [],
	extraUpperCaseWords = [],
}: {
	extraLowerCaseWords?: string[];
	extraUpperCaseWords?: string[];
} = {}): string {
	let defaulLowerCaseWords = [
		'a',
		'aos',
		'às',
		'com',
		'da',
		'das',
		'de',
		'des',
		'do',
		'dos',
		'duma',
		'dumas',
		'dum',
		'duns',
		'e',
		'em',
		'na',
		'nas',
		'no',
		'nos',
		'num',
		'numa',
		'nuns',
		'numas',
		'o',
		'os',
		'pelas',
		'pela',
		'pelo',
		'pelos',
		'por',
		'sem',
	];

	let defaulUpperCaseWords = ['cnpj', 'cpf'];

	if (extraLowerCaseWords) {
		// garante que todas as palavras estão em minúsculas
		extraLowerCaseWords = extraLowerCaseWords.map((word) => word.toLowerCase());
		defaulLowerCaseWords = defaulLowerCaseWords.concat(extraLowerCaseWords);
	}

	if (extraUpperCaseWords) {
		// garante que todas as palavras estão em minúsculas
		extraUpperCaseWords = extraUpperCaseWords.map((word) => word.toLowerCase());
		defaulUpperCaseWords = defaulUpperCaseWords.concat(extraUpperCaseWords);
	}

	const words = this.toLowerCase().split(' ');

	const capitalizedWords = words.map((word, index) => {
		// se a palavra estiver na lista de palavras que devem ser escritas com todas as letras em maiúsculo
		if (defaulUpperCaseWords.includes(word)) {
			return word.toUpperCase();
		}

		// se for a primeira palavra da lista, ou não tiver sido sinalizada como minúscula
		// então a primeira letra deve ser escrita em maiúscula
		if (index === 0 || !defaulLowerCaseWords.includes(word)) {
			return word.charAt(0).toUpperCase() + word.slice(1);
		}

		// caso contrário retorna a palavra em minúscula
		return word;
	});

	return capitalizedWords.join(' ');
};
